import React, { useContext, useEffect, useMemo, useState } from 'react';

import {
  ProgramRequestsContainer,
  ProgramRequestsHeader,
  ProgramRequestsSeeAll,
  ProgramRequestsNavBar,
  ProgramRequestsNavItem,
  ProgramRequestsList,
} from './components';
import useProgramRequest from '../../hooks/programRequest';
import ProgramList from './ProgramList';
import { ProgramStatus } from '../../constants/enums';
import { NotificationContext } from '../../services/NotificationContext';

const statuses = [
  { label: 'All', value: null },
  { label: 'New', value: ProgramStatus.PENDING },
  { label: 'Approved', value: ProgramStatus.APPROVED },
  { label: 'Declined', value: ProgramStatus.DECLINED },
  { label: 'Cancelled', value: ProgramStatus.CANCELLED },
];

const DashboardProgramRequests = ({ openRequest }) => {
  const [active, setActive] = useState('PENDING');
  const { programRequests, programRequestsLoading, programRequestsRefetch } = useProgramRequest({
    requestStatus: active,
  });
  const { notifications } = useContext(NotificationContext);
  useMemo(() => {
    notifications?.length && programRequestsRefetch();
  }, [programRequestsRefetch, notifications]);

  return (
    <ProgramRequestsContainer>
      <ProgramRequestsHeader>
        PROGRAM REQUESTS
        {/* <ProgramRequestsSeeAll>See All</ProgramRequestsSeeAll> */}
      </ProgramRequestsHeader>
      <ProgramRequestsNavBar>
        {statuses.map((status) => (
          <ProgramRequestsNavItem
            key={status.value}
            active={active === status.value}
            onClick={() => setActive(status.value)}
          >
            {status.label}
          </ProgramRequestsNavItem>
        ))}
      </ProgramRequestsNavBar>
      <ProgramRequestsList>
        <ProgramList
          items={programRequests}
          openRequest={openRequest}
          status={active}
          isLoading={programRequestsLoading}
        />
      </ProgramRequestsList>
    </ProgramRequestsContainer>
  );
};

export default DashboardProgramRequests;
